import { ScreenConstants } from './constants/ScreenConstants';

export class ScreenUtils {
  static isMobile(): boolean {
    return window.screen.width < ScreenConstants.MOBILE_MAX_WIDTH;
  }

  static isMobileS(): boolean {
    return window.screen.width < ScreenConstants.MOBILE_S_MAX_WIDTH;
  }

  static isMobileL(): boolean {
    return window.screen.width >= ScreenConstants.MOBILE_S_MAX_WIDTH && window.screen.width < ScreenConstants.MOBILE_MAX_WIDTH ;
  }

  static isTablet(): boolean {
    return window.screen.width >= ScreenConstants.MOBILE_MAX_WIDTH && window.screen.width < ScreenConstants.DESKTOP_MIN_WIDTH ;
  }

  static isDesktop(): boolean {
    return window.screen.width > ScreenConstants.DESKTOP_MIN_WIDTH;
  }
}